interface IPromotionApplicableConditionTypes {
  hotel: string;
  hotelPlan: string;
  hotelRoom: string;
  hotelPlanAndHotelRoom: string;
}

export const PromotionApplicableConditionTypes: IPromotionApplicableConditionTypes =
  {
    hotel: "hotel",
    hotelPlan: "hotel_plan",
    hotelRoom: "hotel_room",
    hotelPlanAndHotelRoom: "hotel_plan_and_hotel_room",
  };
